<template>
  <div class="level-header">
    <h4 class="mb-0">Tiêu chí teamlead</h4>
    <div>
      <el-button
        type="info"
        class="btn btn-info font-weight-bold"
        @click="isImport = true"
      >
        <i class="la la-upload"></i>
        <span>Import</span>
      </el-button>
    </div>

    <el-dialog
      v-if="isImport"
      title="Import tiêu chí teamlead"
      :visible.sync="isImport"
      width="50%"
      :before-close="handleCloseDialog"
    >
      <hr style="margin-top: -20px" />
      <ImportLevelEmployee
        :loadingImport="loadingImport"
        @closeDialog="isImport = false"
        @importData="handleImportData"
      />
    </el-dialog>
  </div>
</template>

<script>
import ImportLevelEmployee from "./ImportLevelEmployee.vue";

export default {
  name: "HeaderLevelEmployee",
  components: { ImportLevelEmployee },
  data() {
    return {
      isImport: false,
      loading: false,
    };
  },
  props: {
    loadingImport: Boolean,
    default: () => {
      return false
    }
  },
  methods: {
    handleCloseDialog() {
      this.isImport = false;
    },
    handleImportData(data) {
      this.loading = true;
      this.$emit("importData", data);
    },
  },
};
</script>

<style scoped>
.level-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
}
</style>

